const capitalizeName = (name: string): string =>
	name ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : name

export const ReportMealSize = (json: IReportMealSize): IReportMealSizeModel => ({
	size: json.size,
	quantity: json.quantity,
})

const MEAL_SIZE_ORDER: Record<string, number> = { XS: 0, S: 1, M: 2, L: 3, XL: 4, XXL: 5 }
const UNKNOWN_MEAL_SIZE_ORDER = 99

const sortMealSizes = (sizes: IReportMealSizeModel[]): IReportMealSizeModel[] =>
	[...sizes].sort((a: IReportMealSizeModel, b: IReportMealSizeModel): number => {
		const orderA: number = MEAL_SIZE_ORDER[a.size] ?? UNKNOWN_MEAL_SIZE_ORDER
		const orderB: number = MEAL_SIZE_ORDER[b.size] ?? UNKNOWN_MEAL_SIZE_ORDER
		return orderA - orderB
	})

export const ReportMeal = (json: IReportMeal): IReportMealModel => {
	const media: IMediaModel[] = json.media?.map(Media) ?? []
	const sizes: IReportMealSizeModel[] = json.sizes?.map(ReportMealSize) ?? []

	return {
		mealId: json.meal_id,
		mealName: json.meal_name,
		mealType: json.meal_type,
		mealTypeName: json.meal_type_name ? capitalizeName(json.meal_type_name) : json.meal_type_name,
		sizes: sortMealSizes(sizes),
		totalQuantity: json.total_quantity,
		imageUrl: media[0]?.originalURL ?? null,
		media,
	}
}

export const ReportDietRow = (json: IReportDietRow): IReportDietRowModel => ({
	dietName: json.diet_name,
	offerName: json.offer_name,
	kcalCounts: json.kcal_counts ?? {},
	total: json.total,
})

export const ReportDietsSummary = (json: IReportDietsSummary): IReportDietsSummaryModel => ({
	kcalTotals: json.kcal_totals ?? {},
	grandTotal: json.grand_total,
})

export const ReportDietsData = (json: IReportDietsData): IReportDietsDataModel => ({
	rows: json.rows.map(ReportDietRow),
	summary: ReportDietsSummary(json.summary),
	kcalColumns: json.kcal_columns,
})

export const ReportMealsFilters = (json: IReportMealsFiltersResponse): IReportMealsFiltersModel => ({
	dateRange: json.date_range,
	dietGroups: json.diet_groups ?? [],
	mealTypes: (json.meal_types ?? []).map((mt: IReportMealTypeOption) => ({
		...mt,
		name: capitalizeName(mt.name),
	})),
	kcal: json.kcal ?? [],
	maxDays: json.max_days ?? 7,
})

export const ReportDietsFilters = (json: IReportDietsFiltersResponse): IReportDietsFiltersModel => ({
	dateRange: json.date_range,
	offers: json.offers ?? [],
	maxDays: json.max_days ?? 7,
})
